import { createFileRoute } from '@tanstack/react-router';
import { OrganizationDocumentsLayout } from '@uturn/portal/modules/org/layouts/documents-layout';

export const Route = createFileRoute(
	'/_protected/org/$orgId/settings/documents',
)({
	component: OrganizationDocumentsLayout,
});
